/**
 * Infrared iBERA — WithdraworLite global-queue read surface.
 *
 * iBERA withdrawals are keyed by a GLOBAL nonce/requestId, not per-user:
 * `iBERA.burn(receiver, shares)` forwards to `WithdraworLite.queue` and
 * returns a `requestId`. There is no `getUserWithdrawals(address)` getter,
 * so enumeration scans the global `requests(requestId)` array and filters
 * by the `receiver` field. Claimability is frontier-based:
 * `requestId < requestsFinalisedUntil()`.
 */
export const IBeraWithdraworAbi = [
  {
    name: 'requests',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ name: 'requestId', type: 'uint256' }],
    outputs: [
      { name: 'state', type: 'uint8' },
      { name: 'timestamp', type: 'uint88' },
      { name: 'receiver', type: 'address' },
      { name: 'amount', type: 'uint128' },
      { name: 'accumulatedAmount', type: 'uint128' },
    ],
  },
  {
    name: 'requestLength',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'requestsFinalisedUntil',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
